import { AuthRepository } from 'src/repositories/AuthRepository'
import { ProfileRepository } from 'src/repositories/ProfileRepository'

export const CommonRepository = {
  removeAllCookies: async () => {
    await Promise.all([
      AuthRepository.removeAccessToken(),
      AuthRepository.removeRefreshToken(),
      AuthRepository.removeUsername(),
      ProfileRepository.removeEmail(),
    ])
  },
} as const
